import React from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import ImageLoader from "../imageLoader/ImageLoader";
import GameView from "../gameVIew/GameView";
import GameViewH from "../gameVIew/GameViewH";
import "./GameListCorousal.css";
import { convertNameFormat } from '../../utils/Common';
import imageBoy from "../../assets/images/viewMoreBoy.jpg"
import imageGirl from "../../assets/images/viewMoreGirl.jpg"

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 8,
  },
  tablet: {
    breakpoint: { max: 1023, min: 464 },
    items: 5,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};
const basicImgData = {
  width: "152px",
  height: "calc(100vw * 0.14)",
};

export default function GameListCorousal({
  title,
  imagesData,
  handleImageLoad,
  viewtype,
  gameLevelId
}) {
  const navigate = useNavigate();
  const ViewComponent = viewtype === "v" ? GameView : GameViewH;
  const viewMoreImage = gameLevelId % 2 === 0 ? imageBoy : imageGirl;
  const goToViewMore = () => {
    window.scrollTo(0, 0);
    navigate(`/games/${convertNameFormat(title)}`);
  };
  // prepare data
  const isRecommendation = title?.toLowerCase() === "recommendations";
  const desktopGames = imagesData?.slice(0, isRecommendation ? 8 : 7);
  const tabletGames = imagesData?.slice(0, isRecommendation ? 5 : 4);
  const mobileGames = imagesData?.slice(0, isRecommendation ? 3 : 2);
  return (
    <div className="corousal-view-container">
      {imagesData?.length ? (
        <>
          <div className="corousal-name">
            <p className="">{title}</p>
            {/* <button
              className="corousal-more-btn"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/games/${convertNameFormat(title)}`);
              }}
            >more...</button> */}
          </div>
          {isRecommendation ? (
            <div className="recommendation-grid">
              {(window.innerWidth >= 1024
                ? desktopGames
                : window.innerWidth >= 464
                  ? tabletGames
                  : mobileGames
              )?.map((image, idx) => (
                <div key={image.id || idx}>
                  <ViewComponent
                    image={image}
                    handleImageLoad={handleImageLoad}
                    isRecommendation={isRecommendation}
                  />
                </div>
              ))}
            </div>
          ) : (
            <Carousel
              responsive={responsive}
              containerClass="corousal-container gametemplate"
              removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
            >
              {(window.innerWidth >= 1024
                ? desktopGames
                : window.innerWidth >= 464
                  ? tabletGames
                  : mobileGames
              )?.map((image, idx) => (
                <div key={image.id || idx}>
                  <ViewComponent
                    image={image}
                    handleImageLoad={handleImageLoad}
                    isRecommendation={isRecommendation}
                  />
                </div>
              ))}

              {/* View More Card */}
              <div className="view-more-card" onClick={goToViewMore}>
                <img src={viewMoreImage} alt="View More" />
                <div className="corousal-image-data-title">View More</div>
              </div>
            </Carousel>
          )}
        </>
      ) : (
        <div className="corousal-loader-view">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((ele, idx) => (
            <div key={idx}>
              <ImageLoader {...basicImgData} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
